import * as React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import cx from 'classnames';

import { Checkbox } from 'components/Checkbox';
import Modal from 'components/Modal/Modal';

import s from './CancellationPolicyAck.module.css';

type CancellationPolicyAckProps = {
  name: string;
  className?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  waitlist?: boolean;
  fee: number;
  policyText: string;
  timeWindow: number;
  value?: boolean;
  register?: UseFormRegisterReturn;
  error?: string;
};

const CancellationPolicyAck: React.FC<CancellationPolicyAckProps> = ({
  name,
  className,
  onChange,
  waitlist,
  fee,
  policyText,
  timeWindow,
  value,
  register,
  error,
}) => {
  const modalId = 'cancellation-policy-modal';
  const remainingText = (): string => {
    if (timeWindow && fee)
      return `, ${timeWindow}hrs advance notice & a ${fee}% cancellation fee.`;
    if (timeWindow) return `, ${timeWindow}hrs advance notice.`;
    if (fee) return `, a ${fee}% cancellation fee.`;
    return '.';
  };

  const onClick = () => {
    const modal = document.getElementById(modalId);

    if (modal) {
      // commenting as hidePopover is not YET in the Event type properties
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      modal.showPopover();
    }
  };

  return (
    <>
      <Modal id={modalId} title="Cancellation Policy" className={s.modal}>
        {policyText}
      </Modal>
      <Checkbox
        id="cancellation-policy"
        name={name}
        className={cx(s.root, className)}
        onChange={onChange}
        value={value}
        register={register}
        error={error}
        label={
          <span className={s.policy}>
            {'I acknowledge & accept the '}
            <button
              type="button"
              className={s.textButton}
              // eslint-disable-next-line react/no-unknown-property
              popovertarget={modalId}
              // eslint-disable-next-line react/no-unknown-property
              popovertargetaction="show"
              onClick={onClick}
            >
              Cancellation Policy
            </button>
            {waitlist && ' upon booking confirmation'}
            {remainingText()}
          </span>
        }
      />
    </>
  );
};

export { CancellationPolicyAck };
